module.exports = __webpack_public_path__ + "static/media/view2.65bd151d.jpg";